<script>
import { ArticleTag } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit ArticleTag',
      addRoute: { name: 'Add ArticleTag' },
      verboseName: 'Tag artykułu',
      verboseNamePlural: 'Tagi artykułów',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name_pl', label: 'nazwa (pl)' },
        { prop: 'name_en', label: 'nazwa (en)' },
        { prop: 'slug_pl', label: 'slug (pl)' },
        { prop: 'slug_en', label: 'slug (en)' }
      ]
    }
  },
  computed: {
    service() {
      return ArticleTag
    }
  }
}
</script>
